import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachAthleteStatisticsPage } from "src/pages/CoachAthleteStatisticsPage";

const searchSchema = z.object({
  exercise: z.string().optional(),
  exerciseName: z.string().optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/statistics",
)({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  return <CoachAthleteStatisticsPage />;
}
